'use client'

import { memo } from 'react'

import ChartCardLoading from '@/components/charts/components/ChartCardLoading'

const ChartInterestRateModelLoading = () => {
  return <ChartCardLoading className="grow" padding="s" header={false} chartClassName="h-[288px]" />
}

export default memo(ChartInterestRateModelLoading)
